export default __webpack_public_path__ + "static/media/icn-bac-passed.f894e8a1.svg";